import DataTable from './dataTable'
import Vue from 'vue'

/******************************************************************************
 *  Facebook
 *****************************************************************************/

/**
 * @type {Facebook}
 */
export default class Facebook extends DataTable {

    constructor() {
        super('/integrations/facebook/forms', '/facebook/forms')
        this.columns = [
            this.prototypes.column('updated_at', 'updated_at', true, true),
            this.prototypes.column('form_name', 'form_name', true, false),
            this.prototypes.column('form_id', 'form_id', true, false)
        ]
    }

    /**
     * Requisição para desativar integração com o Facebook
     */
    deactivateFacebookIntegration() {
        return this.update('/disable', '', {}).then(response => {
            Vue.prototype.$toastr.s(response.data.msg)
            return this.http.put('/integrations/facebook/accounts/disable').then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
        })
    }

    /**
     * Recebe um conjunto de form_id's e verifica quais já estão integrados
     * 
     * @param {Array} params 
     * @returns
     */
    checkIntegration(params) {
        return this.http.post(
            this.constructor.normalize(this.resource, 'checkintegration'),
            params
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
}
